import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  question: '¿Necesito materiales caros o difíciles de conseguir?',
  answer: 'No, usamos elementos naturales y básicos que probablemente ya tienes en tu cocina (sal, agua, hierbas comunes como romero o ruda). El poder está en la técnica y la intención, no en gastar dinero en herramientas costosas.'
}, {
  question: '¿Este método pertenece a alguna religión específica?',
  answer: 'No. Es espiritualidad práctica basada en leyes energéticas universales. Funciona independientemente de tus creencias religiosas, ya que trabaja directamente con la física de tu campo electromagnético (aura).'
}, {
  question: '¿Cuánto tiempo me tomará hacer los ejercicios?',
  answer: 'Los ejercicios de la guía están diseñados para personas ocupadas. Toman menos de 30 minutos al día durante los 3 días del protocolo. Después del tercer día, el mantenimiento es mínimo.'
}, {
  question: '¿Puedo aplicar esta protección para mi familia y mi hogar?',
  answer: 'Sí, absolutamente. El manual incluye secciones específicas que explican cómo extender tu escudo de protección a tu hogar, tus espacios de trabajo y tus seres queridos.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const toggleFaq = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section className="py-20 bg-[#0a0e27] relative" data-id="element-37">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-38">
        <div className="text-center mb-12" data-id="element-39">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-40">
            Preguntas Frecuentes
          </h2>
          <p className="text-gray-400" data-id="element-41">
            Resolvemos tus dudas antes de comenzar tu proceso de liberación.
          </p>
        </div>

        <div className="space-y-4" data-id="element-42">
          {faqs.map((faq, index) => <div key={index} className={`border rounded-2xl transition-all duration-300 ${openIndex === index ? 'bg-[#1a1f3a] border-yellow-500/50 shadow-[0_0_15px_rgba(212,175,55,0.1)]' : 'bg-[#1a1f3a]/50 border-white/10 hover:border-white/20'}`} data-id="element-43">
              <button className="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none" onClick={() => toggleFaq(index)} aria-expanded={openIndex === index} data-id="element-44">
                <span className="text-lg font-semibold text-white pr-4" data-id="element-45">
                  {faq.question}
                </span>
                <ChevronDown className={`w-5 h-5 text-yellow-400 flex-shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-46" />
              </button>

              <div className={`overflow-hidden transition-all duration-300 ease-in-out ${openIndex === index ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-47">
                <div className="px-6 pb-5 text-gray-300 leading-relaxed" data-id="element-48">
                  {faq.answer}
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}